import React, { useContext } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Icon, Table } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import { CoolFarmOptionsContext } from '../../..'

interface FeedAdditiveItemProps {
  index: number
  id: string
  herdIndex: number
  removeFeedAdditive: (index: number) => void
}

const FeedAdditiveItem: React.FC<FeedAdditiveItemProps> = ({
  index,
  id,
  herdIndex,
  removeFeedAdditive
}) => {
  const { t } = useTranslation()
  const { control } = useFormContext()
  const options = useContext(CoolFarmOptionsContext)

  const feedAdditiveTypeOptions = options?.feedAdditiveTypes?.map(type => ({
    key: type.key,
    value: type.key,
    text: type.label
  })) || []

  const feedAdditiveDoseUnitOptions = options?.feedAdditiveDoseUnits?.map(unit => ({
    key: unit.key,
    value: unit.key,
    text: unit.label
  })) || []

  return (
    <Table.Row key={id}>
      <Table.Cell>
        <FormFields.Select
          control={control}
          name={`herdGroups.${herdIndex}.feedAdditives[${index}].type`}
          options={feedAdditiveTypeOptions}
          rules={{ required: true }}
          placeholder={t('Select type')}
          withoutLabel
          noErrorMessage
        />
      </Table.Cell>
      <Table.Cell>
        <FormFields.Input
          control={control}
          name={`herdGroups.${herdIndex}.feedAdditives[${index}].dose`}
          rules={{ required: true }}
          placeholder={t('Enter dose')}
          typeInput='controled'
          allowDecimals
          decimalScale={2}
          withoutAsterisk
          noErrorMessage
        />
      </Table.Cell>
      <Table.Cell>
        <FormFields.Select
          control={control}
          name={`herdGroups.${herdIndex}.feedAdditives[${index}].doseUnit`}
          options={feedAdditiveDoseUnitOptions}
          rules={{ required: true }}
          placeholder={t('Select unit')}
          withoutLabel
          noErrorMessage
        />
      </Table.Cell>
      <Table.Cell>
        <FormFields.Input
          control={control}
          name={`herdGroups.${herdIndex}.feedAdditives[${index}].days`}
          rules={{ required: true }}
          placeholder={t('Enter days')}
          typeInput='controled'
          allowDecimals={false}
          withoutAsterisk
          noErrorMessage
        />
      </Table.Cell>
      <Table.Cell>
        <FormFields.Input
          control={control}
          name={`herdGroups.${herdIndex}.feedAdditives[${index}].herdCategoryPercentage`}
          rules={{ required: true }}
          placeholder={t('Enter %')}
          typeInput='controled'
          allowDecimals
          decimalScale={2}
          suffix=' %'
          withoutAsterisk
          noErrorMessage
        />
      </Table.Cell>
      <Table.Cell textAlign='center'>
        <Icon
          name='trash'
          color='red'
          style={{ cursor: 'pointer', fontSize: '1.2em' }}
          onClick={() => removeFeedAdditive(index)}
        />
      </Table.Cell>
    </Table.Row>
  )
}

export default FeedAdditiveItem
